import { useState, type ChangeEvent } from "react";

export const useAttach = (onFilesChange?: (files: File[]) => void) => {
  const [files, setFiles] = useState<File[]>([]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    const newFiles = Array.from(e.target.files);
    setFiles((prev) => {
      const updatedFiles = [...prev, ...newFiles];
      if (onFilesChange) onFilesChange(updatedFiles);
      return updatedFiles;
    });
  };

  const handleRemoveFile = (fileToRemove: File) => {
    setFiles((prev) => {
      const updatedFiles = prev.filter((f) => f !== fileToRemove);
      if (onFilesChange) onFilesChange(updatedFiles);
      return updatedFiles;
    });
  };

  return {
    files,
    handleFileChange,
    handleRemoveFile,
  };
};
